import { render } from "./SinglePractice.vue?vue&type=template&id=7cdfb4f3&scoped=true"
import script from "./SinglePractice.vue?vue&type=script&lang=js"
export * from "./SinglePractice.vue?vue&type=script&lang=js"

import "./SinglePractice.vue?vue&type=style&index=0&id=7cdfb4f3&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cdfb4f3"]])

export default __exports__